import "./sass/index.scss";
import { renderToDOM } from "./App";

renderToDOM(document.getElementById("root"));
